import { makeStyles } from '@material-ui/core/styles';
import { black_main, grey_dark, grey_medium } from '@theme/customTheme';

export const useStyles = makeStyles(theme => ({
  stepTwo: {
    maxWidth: '736px',
  },
  orDivider: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    maxWidth: '736px',
    marginBottom: '20px',
  },
  orLine: {
    flex: 1,
    height: '1px',
    backgroundColor: '#D8DFE5',
  },
  orText: {
    color: '#000000',
    fontFamily: 'Open Sans',
    fontSize: '14px',
    lineHeight: '24px',
    margin: '0',
  },
  gridMobileItem: {
    '@media (max-width:480px)': {
      margin: 0,
      padding: '0px !important',
    },
  },
  searchAutocompleteInput: {
    outline: 'none',
    border: `1px solid ${grey_medium}`,
    borderRadius: '4px',
    padding: '12px 16px',
    color: black_main,
    fontSize: '14px',
    lineHeight: '24px',
    borderColor: grey_medium,
    width: '100%',
    paddingLeft: '52px',
    '&::placeholder': {
      fontSize: '14px',
      color: grey_dark,
      lineHeight: '24px',
      textTransform: 'capitalize',
      opacity: 1,
    },
  },
  inputContainer: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    position: 'relative',
  },
  icon: {
    marginRight: theme.spacing(1),
    color: '#000000DE',
    opacity: '0.87',
    position: 'absolute',
    left: '16px',
  },
}));
